module.exports = __webpack_public_path__ + "media/images/dashboard/img_3-4911c5056fcd64e99b014e90eddf8c68.jpg";